import { Box, Card, CardContent, Chip, Divider, Grid, TextField, Typography, IconButton } from '@mui/material'
import { useState } from 'react'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import TagIcon from '@mui/icons-material/Tag'
import DeleteIcon from '@mui/icons-material/Delete'

const UseCaseCard = ({ useCaseFunction, editMode, onUpdateOrder, onDelete }) => {
  const [openDialog, setOpenDialog] = useState(false)
  const [orderValue, setOrderValue] = useState(useCaseFunction.order)
  const [orderError, setOrderError] = useState('')

  const handleConfirmOrder = () => {
    if (!orderValue && orderValue !== 0) {
      setOrderError('Required')
      return
    }
    const result = onUpdateOrder(orderValue)
    if (result?.error) {
      setOrderError(result.error)
      return
    }
    setOrderError('')
    setOpenDialog(false)
  }

  const handleClose = () => {
    setOrderValue(useCaseFunction.order)
    setOrderError('')
    setOpenDialog(false)
  }

  return (
    <>
      <SmartDialog
        title={{ icon: <TagIcon fontSize='large' />, render: <Typography variant='h4'>Edit Order</Typography> }}
        setOpen={openDialog}
        acceptCallback={handleConfirmOrder}
        cancelCallback={handleClose}
        renderComponent={
          <TextField
            autoFocus
            fullWidth
            type='number'
            label='Order'
            value={orderValue}
            onChange={(e) => { setOrderValue(e.target.value); setOrderError('') }}
            error={!!orderError}
            helperText={orderError}
            sx={{ mt: 1 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleConfirmOrder()
              if (e.key === 'Escape') handleClose()
            }}
          />
        }
      />
      <Grid item xs={12} sm={6} lg={4}>
        <Card
          variant='outlined'
          sx={{
            height: '100%',
            borderRadius: 2,
            borderColor: 'primary.main',
            borderWidth: 1.5,
            cursor: editMode ? 'pointer' : 'default'
          }}
          onClick={editMode ? () => { setOrderValue(useCaseFunction.order); setOpenDialog(true) } : null}
        >
          <CardContent sx={{ p: 2.5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
              <Typography variant='h6' fontWeight={600} color='primary'>
                {useCaseFunction.function}
              </Typography>
              <Chip
                label={`Order ${useCaseFunction.order}`}
                size='small'
                color='primary'
                variant='outlined'

              />
            </Box>
            <Divider sx={{ mb: 1.5 }} />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1
              }}
            >
              <Typography variant='body2' color='text.secondary' fontWeight={500}>
                {useCaseFunction.useCase?.name || 'N/A'}
              </Typography>

              {editMode && (
                <IconButton
                  size='small'
                  color='error'
                  onClick={(e) => {
                    e.stopPropagation()
                    onDelete(useCaseFunction.id)
                  }}
                >
                  <DeleteIcon fontSize='small' />
                </IconButton>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </>
  )
}

export default UseCaseCard
